import React from 'react';
import styles from './TokenSection.module.css';

/**
 * TokenSection Component
 * Displays token information with "Coming Soon" overlay
 * Follows JACKOPOT design system
 */
const TokenSection = ({ isCollapsed = false }) => {
  return (
    <div className={`${styles.tokenSection} ${isCollapsed ? styles.collapsed : ''}`}>
      {/* Coming Soon Overlay - Shows on hover for both states */}
      <div className={styles.comingSoonOverlay}>
        <span className={styles.comingSoonText}>Coming Soon</span>
      </div>

      {/* Token Content */}
      <div className={styles.tokenContent}>
        {isCollapsed ? (
          /* Collapsed: Show only image with border */

            <img
              src="/assets/images/token/sc.webp"
              alt="JACKOPOT Token"
              className={styles.tokenIconImage}
              onError={(e) => {
                e.target.src = '/assets/images/sc.png';
              }}
            />
        
        ) : (
          /* Expanded: Show full token info */
          <>
            <div className={styles.tokenHeader}>
              <img
                src="/assets/images/token/sc.webp"
                alt="JACKOPOT Token"
                className={styles.tokenIcon}
                onError={(e) => {
                  e.target.src = '/assets/images/sc.png';
                }}
              />
              <div className={styles.tokenInfo}>
                <div className={styles.tokenName}>
                  Jackopot <span>(JKP)</span>
                </div>
                <div className={styles.tokenPrice}>
                  <span>$0.1849</span>
                  <span className={styles.priceChange}>+0.75%</span>
                </div>
              </div>
            </div>
            <div className={styles.tokenActions}>
              <button className={styles.tokenButton}>Buy / Sell</button>
              <button className={`${styles.tokenButton} ${styles.tokenButtonPrimary}`}>
                Dashboard
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TokenSection;
